(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moudhy-boarding-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function initMboChecks(scope) {
    scope.querySelectorAll('.mbo__includes:not([data-mbo-checks])').forEach(function (list) {
      var rows = Array.from(list.children).filter(function (row) { return row.tagName === 'LI'; });
      var motion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!rows.length || !('IntersectionObserver' in window) || (motion && motion.matches)) {
        list.setAttribute('data-mbo-checks', 'static');
        return;
      }
      var observer;
      var nextStart = 0;
      var remaining = rows.length;
      function stop() {
        if (observer) observer.disconnect();
        list.setAttribute('data-mbo-checks', 'static');
        if (motion && motion.removeEventListener) motion.removeEventListener('change', onMotionChange);
        delete list.mboChecksCleanup;
      }
      function onMotionChange(event) { if (event.matches) stop(); }
      try {
        observer = new IntersectionObserver(function (entries) {
          var now = performance.now();
          entries.filter(function (entry) {
            return entry.isIntersecting && entry.intersectionRatio >= .55;
          }).sort(function (a, b) {
            return rows.indexOf(a.target) - rows.indexOf(b.target);
          }).forEach(function (entry) {
            var row = entry.target;
            if (row.classList.contains('mbo__check--visible')) return;
            var start = Math.max(now + 90, nextStart);
            row.style.setProperty('--mbo-check-delay', Math.round(start - now) + 'ms');
            row.classList.add('mbo__check--visible');
            nextStart = start + 240;
            observer.unobserve(row);
            remaining -= 1;
          });
          if (!remaining) observer.disconnect();
        }, { threshold:.55, rootMargin:'0px 0px -32px 0px' });
        list.mboChecksCleanup = stop;
        list.setAttribute('data-mbo-checks', 'ready');
        rows.forEach(function (row) { observer.observe(row); });
        if (motion && motion.addEventListener) motion.addEventListener('change', onMotionChange);
      } catch (error) {
        stop();
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMboChecks(document); }, { once:true });
  } else {
    initMboChecks(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initMboChecks(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.mbo__includes').forEach(function (list) {
      if (list.mboChecksCleanup) list.mboChecksCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moudhy-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || !Element.prototype.animate || !window.matchMedia) return;
  var instances = new WeakMap();
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function eachRoot(scope, callback) {
    if (scope.matches && scope.matches('.mhero')) callback(scope);
    scope.querySelectorAll('.mhero').forEach(callback);
  }

  function setup(root) {
    if (instances.has(root) || motion.matches) return;
    var observer;
    var animations = new Set();
    var stopped = false;

    function stop() {
      stopped = true;
      if (observer) observer.disconnect();
      animations.forEach(function (animation) { animation.cancel(); });
      animations.clear();
      root.removeEventListener('focusin', stop);
      if (motion.removeEventListener) motion.removeEventListener('change', onMotionChange);
      else if (motion.removeListener) motion.removeListener(onMotionChange);
    }
    function onMotionChange() { if (motion.matches) stop(); }
    function reveal(target, delay, isPrice) {
      if (!target || stopped || motion.matches || !root.isConnected) return;
      try {
        // Content is visible by default; no counter, loop or persistent hidden state.
        var animation = target.animate([
          { opacity: 0, transform: isPrice ? 'translateY(18px) scale(.98)' : 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0) scale(1)' }
        ], { duration: isPrice ? 900 : 700, delay: delay, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'backwards' });
        animations.add(animation);
        animation.onfinish = animation.oncancel = function () { animations.delete(animation); };
      } catch (error) { stop(); }
    }

    try {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var target = entry.target;
          observer.unobserve(target);
          if (target.classList.contains('mhero__meta')) {
            reveal(target.querySelector('.mhero__price-main'), 0, true);
            reveal(target.querySelector('.mhero__price-note'), 120, false);
            reveal(target.querySelector('.mhero__divider'), 160, false);
            reveal(target.querySelector('.mhero__product'), 200, false);
          } else {
            reveal(target, target.classList.contains('mhero__btn') ? 180 : 0, false);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px 24px 0px' });
      instances.set(root, stop);
      root.querySelectorAll('.mhero__kicker, .mhero__title, .mhero__text, .mhero__meta, .mhero__btn').forEach(function (target) { observer.observe(target); });
      root.addEventListener('focusin', stop);
      if (motion.addEventListener) motion.addEventListener('change', onMotionChange);
      else if (motion.addListener) motion.addListener(onMotionChange);
    } catch (error) { stop(); }
  }

  function init(scope) { eachRoot(scope, setup); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    eachRoot(event.target, function (root) {
      var stop = instances.get(root);
      if (stop) stop();
      instances.delete(root);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moudhy-how-it-works"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('moudhy-how-steps')) {
  customElements.define('moudhy-how-steps', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.steps = Array.from(this.querySelectorAll('[data-mhiw-step]'));
      this.images = Array.from(this.querySelectorAll('[data-mhiw-image]'));
      this.mobile = matchMedia('(max-width: 990px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      if (!this.steps.length) return;
      this.steps.forEach((step, index) => step.addEventListener('click', () => {
        if (this.mobile.matches || this.motion.matches) this.activate(index, 1);
        else {
          const top = window.scrollY + this.getBoundingClientRect().top;
          const distance = this.offsetHeight - window.innerHeight;
          window.scrollTo({ top: top + distance * (index + 0.1) / this.steps.length, behavior: 'smooth' });
        }
      }, options));
      const refresh = () => { this.measure(); this.onScroll(); };
      window.addEventListener('resize', refresh, options);
      this.motion.addEventListener('change', refresh, options);
      window.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.onScroll(); });
      }, { passive: true, signal: this.abort.signal });
      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      this.activate(0, 1);
      this.measure();
      this.onScroll();
    }
    measure() {
      this.steps.forEach(step => {
        const box = step.querySelector('[data-mhiw-titlebox]');
        const title = step.querySelector(step.classList.contains('is-active') ? '.mhiw__step-title--large' : '.mhiw__step-title--small');
        if (box && title) box.style.height = title.offsetHeight + 'px';
      });
    }
    activate(index, progress) {
      this.index = index;
      this.steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === index);
        step.setAttribute('aria-expanded', i === index ? 'true' : 'false');
        step.querySelector('.mhiw__step-text').setAttribute('aria-hidden', i === index ? 'false' : 'true');
        step.querySelector('[data-mhiw-fill]').style.height = (i < index ? 100 : i === index ? Math.round(progress * 100) : 0) + '%';
      });
      const key = String(index);
      const hasImage = this.images.some(image => image.dataset.mhiwImage === key);
      this.images.forEach(image => {
        const visible = image.dataset.mhiwImage === key || (!hasImage && image.dataset.mhiwImage === 'default');
        image.classList.toggle('is-visible', visible);
        image.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (image.classList.contains('mhiw__app')) image.inert = !visible;
      });
      this.measure();
    }
    onScroll() {
      if (this.mobile.matches || this.motion.matches) return;
      const distance = this.offsetHeight - window.innerHeight;
      if (distance <= 0) return;
      const progress = Math.min(1, Math.max(0, -this.getBoundingClientRect().top / distance));
      const position = Math.min(this.steps.length - 0.0001, progress * this.steps.length);
      this.activate(Math.floor(position), position - Math.floor(position));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moudhy-journey-rewards"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || !Element.prototype.animate || !window.matchMedia) return;

  var instances = new WeakMap();
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 750px)');

  function eachRoot(scope, callback) {
    if (scope.matches && scope.matches('.mjr')) callback(scope);
    scope.querySelectorAll('.mjr').forEach(callback);
  }

  function setup(root) {
    if (instances.has(root) || motion.matches) return;
    var steps = Array.prototype.slice.call(root.querySelectorAll('.mjr__step'));
    var targets = root.querySelectorAll('.mjr__eyebrow, .mjr__story > h2, .mjr__intro, .mjr__step, .mjr__cta, .mjr__terms');
    var animations = new Set();
    var observer;
    var stopped = false;

    function stop() {
      stopped = true;
      if (observer) observer.disconnect();
      animations.forEach(function (animation) { animation.cancel(); });
      animations.clear();
      root.removeEventListener('focusin', stop);
      if (motion.removeEventListener) motion.removeEventListener('change', onMotionChange);
      else if (motion.removeListener) motion.removeListener(onMotionChange);
    }

    function onMotionChange() {
      if (motion.matches) stop();
    }

    try {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var target = entry.target;
          observer.unobserve(target);
          if (stopped || motion.matches || !root.isConnected) return;
          var delay = 0;
          var stepIndex = steps.indexOf(target);
          if (stepIndex !== -1 && root.classList.contains('mjr--compact') && wide.matches) delay = stepIndex * 110;
          else if (target.tagName === 'H2') delay = 60;
          else if (target.classList.contains('mjr__intro')) delay = 120;

          try {
            // Backwards fill covers the brief stagger only; content stays visible without JavaScript.
            var animation = target.animate([
              { opacity: 0, transform: 'translateY(20px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 650, delay: delay, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' });
            animations.add(animation);
            animation.onfinish = animation.oncancel = function () { animations.delete(animation); };
          } catch (error) {
            stop();
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 24px 0px' });
      instances.set(root, stop);
      targets.forEach(function (target) { observer.observe(target); });
      root.addEventListener('focusin', stop);
      if (motion.addEventListener) motion.addEventListener('change', onMotionChange);
      else if (motion.addListener) motion.addListener(onMotionChange);
    } catch (error) {
      stop();
    }
  }

  function init(scope) { eachRoot(scope, setup); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    eachRoot(event.target, function (root) {
      var stop = instances.get(root);
      if (stop) stop();
      instances.delete(root);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moudhy-purchase-choice"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initMoudhyChoice(){
    document.querySelectorAll('.mchoice:not([data-choice-ready])').forEach(function(root){
      root.setAttribute('data-choice-ready','');
      if(!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches){
        root.classList.add('is-visible');
        return;
      }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            root.classList.add('is-visible');
            io.disconnect();
          }
        });
      },{threshold:.12,rootMargin:'0px 0px -50px 0px'});
      io.observe(root);
    });
  }
  initMoudhyChoice();
  document.addEventListener('shopify:section:load',initMoudhyChoice);
})();

  } catch(e) { console.error(e); }
})();
})();
